import { UseMutationOptions, useQueryClient } from "@tanstack/react-query";

import { graphql } from "lib/generated/app-service-gql";
import {
  DismissLeadSuggestedContactMutation,
  DismissLeadSuggestedContactMutationVariables,
} from "lib/generated/app-service-gql/graphql";
import { useGraphQlMutation } from "lib/hooks/api/useGraphQlClient";

const DISMISS_LEAD_SUGGESTED_CONTACT_MUTATION = graphql(`
  mutation dismissLeadSuggestedContact($leadId: String!, $suggestionId: String!) {
    dismissLeadSuggestedContact(leadId: $leadId, suggestionId: $suggestionId)
  }
`);

/**
 * Dismisses a single AI-suggested contact for a lead. Refetches the lead on success so the
 * dismissed suggestion drops out of the list.
 */
export function useDismissLeadSuggestedContact(
  leadId: string,
  options?: UseMutationOptions<
    DismissLeadSuggestedContactMutation,
    unknown,
    DismissLeadSuggestedContactMutationVariables,
    unknown
  >,
) {
  const queryClient = useQueryClient();

  return useGraphQlMutation(DISMISS_LEAD_SUGGESTED_CONTACT_MUTATION, {
    ...options,
    onSuccess: async (data, variables, context) => {
      await queryClient.invalidateQueries(["lead", leadId]);
      options?.onSuccess?.(data, variables, context);
    },
  });
}
